export const setFitmentFilters = (searchCtx, fitmentData) => {
    if (fitmentData.makeSlug) searchCtx.addFilters('makeSlug', [fitmentData.makeSlug, 'none'])
    if (fitmentData.modelSlug) searchCtx.addFilters('modelSlug', [fitmentData.modelSlug, 'none'])
    if (fitmentData.year) {
        searchCtx.addFilters('year', '0', '=')
        searchCtx.addFilters('year', fitmentData.year, '=')
    }
    if (fitmentData.bedSlug) searchCtx.addFilters('bedSlug', [fitmentData.bedSlug, 'none'])
    if (fitmentData.bodySlug) searchCtx.addFilters('bodySlug', [fitmentData.bodySlug, 'none'])
    if (fitmentData.engineSlug) searchCtx.addFilters('engineSlug', [fitmentData.engineSlug, 'none'])
}
